import api from './api';

export const createAssignment = async (assignmentData) => {
  const response = await api.post('/assignments/', assignmentData);
  return response.data;
};

export const getAssignmentsByProject = async (projectId) => {
  const response = await api.get(`/assignments/project/${projectId}`);
  return response.data;
};

export const getAssignmentById = async (assignmentId) => {
  const response = await api.get(`/assignments/${assignmentId}`);
  return response.data;
};

export const updateAssignment = async (assignmentId, assignmentData) => {
  const response = await api.put(`/assignments/${assignmentId}`, assignmentData);
  return response.data;
};

export const deleteAssignment = async (assignmentId) => {
  const response = await api.delete(`/assignments/${assignmentId}`);
  return response.data;
};

export const getPendingAssignments = async (projectId) => {
  const response = await api.get(`/assignments/project/${projectId}/pending`);
  return response.data;
};

export const submitAssignmentWithUrls = async (assignmentId, submissionData) => {
  const response = await api.post(`/assignments/${assignmentId}/submit`, submissionData);
  return response.data;
};

export const getMySubmission = async (assignmentId) => {
  const response = await api.get(`/assignments/${assignmentId}/submission`);
  return response.data;
};

export const getAssignmentSubmissions = async (assignmentId) => {
  const response = await api.get(`/assignments/${assignmentId}/submissions`);
  return response.data;
};

export const gradeSubmission = async (submissionId, gradeData) => {
  const response = await api.post(`/assignments/submissions/${submissionId}/grade`, gradeData);
  return response.data;
};

export const markAssignmentComplete = async (assignmentId, completeData) => {
  const response = await api.post(`/assignments/${assignmentId}/mark-complete`, completeData);
  return response.data;
};

// Mentor records "not done" / "half done". Separate from mark-complete, which
// is the only outcome that carries a score.
export const markAssignmentOutcome = async (assignmentId, status, note = null) => {
  const response = await api.post(`/assignments/${assignmentId}/mark-outcome`, { status, note });
  return response.data;
};

// Student ticks one task off the assignment's checklist. Progress only — this
// does not submit the assignment.
export const toggleAssignmentTask = async (assignmentId, taskKey, done, asMentor = false) => {
  const url = `/assignments/${assignmentId}/tasks${asMentor ? '/mentor' : ''}`;
  const response = await api.patch(url, { task_key: taskKey, done });
  return response.data;
};
